import { render } from "./PCDisplay.vue?vue&type=template&id=5c051b2c"
import script from "./PCDisplay.vue?vue&type=script&lang=js"
export * from "./PCDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__